
export const POSE_LIBRARY: Record<string, string[]> = {
    "SELFIE": [
        "Close-up selfie, gentle smile.",
        "Soft smirk, head tilted.",
        "Chin slightly raised, casual relaxed expression.",
        "Looking directly into camera, natural smile, shoulders angled.",
        "Leaning slightly forward, playful grin.",
        "Turning head slightly left, calm smile.",
        "Turning head slightly right, open natural expression.",
        "Half-profile selfie, relaxed eyes, small smile.",
        "Neutral expression.",
        "Relaxed posture, soft gaze.",
        "Selfie with head tilted back slightly, confident look.",
        "Forehead-to-camera angle, bright smile.",
        "Bold confident expression.",
        "Soft, candid smile, relaxed shoulders.",
        "Looking away from camera then back, half-smile.",
        "Selfie with playful eyebrow raise.",
        "Gentle pout, relaxed posture.",
        "Calm, serene expression, slightly lowered chin.",
        "Laughing expression, natural candid pose.",
        "Subtle smirk, light head turn.",
        "Eyes closed softly, peaceful expression.",
        "Leaned slightly to one side, relaxed glance.",
        "Slight over-the-shoulder selfie look.",
        "Half-tilted selfie with soft smile.",
        "Gentle expression with chin tucked slightly.",
        "Calm, thoughtful look into the camera.",
        "Slight lean backward, natural smile.",
        "Flirty smile, slight head tilt.",
        "Relaxed full-face selfie, warm friendly expression."
    ],
    "STUDIO PORTRAIT": [
        "Standing straight, chin up slightly, confident expression.",
        "Three-quarter turn, relaxed smile.",
        "Shoulders back, serene neutral expression.",
        "Head turned slightly left, soft smile.",
        "Arms loosely by sides, confident posture.",
        "Classic portrait stance, gentle expression.",
        "Facing camera with subtle smirk.",
        "Side profile, soft gaze forward.",
        "Chin slightly tucked, elegant posture.",
        "Head tilted back a touch, confident look.",
        "Relaxed shoulders, calm expression.",
        "Three-quarter body pose, neutral gaze.",
        "Slight head tilt, refined smile.",
        "Soft expression with chin angled up.",
        "Relaxed upright posture, serious expression.",
        "Half-turned torso with gentle smile.",
        "Subtle over-the-shoulder look.",
        "Closed-mouth smile, relaxed stance.",
        "Intense gaze, slight forward lean.",
        "Neutral stance, minimal expression.",
        "Standing tall, chin slightly lifted.",
        "Relaxed stance with softened gaze.",
        "Light half-smile, turned torso.",
        "Calm, artistic portrait gaze.",
        "Balanced posture, confident demeanor.",
        "Slight turn with gentle expression.",
        "Upright stance with focused eyes.",
        "Classic portrait face-forward.",
        "Three-quarter profile, soft eyes.",
        "Strong posture, refined expression."
    ],
    "FASHION": [
        "One leg slightly forward, confident runway stance.",
        "Sharp three-quarter turn, fierce expression.",
        "Hip popped slightly, editorial vibe.",
        "Dramatic lean backward, bold look.",
        "One hand on waist, confident posture.",
        "Strong jawline angle toward camera.",
        "Runway-style stride pose.",
        "One knee bent, slight lean.",
        "Torso twisted slightly, intense gaze.",
        "Weight shifted back, poised expression.",
        "Shoulder angled toward camera, sharp look.",
        "Controlled, elegant full-body posture.",
        "Slight lean forward with commanding gaze.",
        "One leg crossed in front.",
        "Turned profile with strong facial angle.",
        "Elbows relaxed, assertive stance.",
        "Fashion-forward exaggerated posture.",
        "Strong geometric pose with body lines.",
        "Intentional asymmetrical stance.",
        "Bold chin lift, runway intensity.",
        "Wide-leg editorial stance.",
        "Torso tilt with intense eye contact.",
        "Classic high-fashion elongated pose.",
        "Slight arch in back, confident posture.",
        "Dynamic head turn, serious gaze.",
        "Twisted torso with elongated arms.",
        "Angular pose emphasizing lines.",
        "Power-stance, legs apart.",
        "Strong silhouette-forward posture.",
        "Fashion-magazine-style confident stance."
    ],
    "EDITORIAL": [
        "Dramatic head tilt, expressive eyes.",
        "Unusual body angle, artistic posture.",
        "Slightly twisted torso, intense stare.",
        "Leaning motion.",
        "Over-the-shoulder expressive look.",
        "Elongated neck pose, artistic mood.",
        "Wide stance with dramatic expression.",
        "Asymmetrical body position.",
        "Strong emotional facial expression.",
        "Dynamic turn of head.",
        "Minimalist neutral but intense look.",
        "Arching slightly backward.",
        "Experimental tilt of shoulders.",
        "Emotional expression—soft sadness.",
        "Poetic, dreamy upward gaze.",
        "Angular full-body pose.",
        "Soft, introspective gaze downward.",
        "Expressive sideways lean.",
        "Dramatic focus on profile.",
        "Body slightly twisted with soft gaze.",
        "High-art expressive look.",
        "Hands relaxed, expressive face.",
        "Tension in posture for dramatic effect.",
        "Head thrown back slightly, emotion-driven.",
        "Fluid movement captured mid-gesture.",
        "Wide stance with contemplative gaze.",
        "Powerful full-body stillness.",
        "Dreamy faraway expression.",
        "Poetic face-up inclination.",
        "Stylized, high-fashion editorial posture."
    ],
    "TRAVEL VLOG": [
        "Casual upright pose, relaxed smile.",
        "Looking off to the side with curiosity.",
        "Slight forward lean, excited expression.",
        "Natural relaxed stance, candid smile.",
        "Mid-step walking pose.",
        "Cheerful half-turn toward camera.",
        "Relaxed posture, soft gaze.",
        "Looking upward with awe.",
        "Turning head over shoulder with smile.",
        "Natural laugh, candid moment.",
        "Neutral pose with relaxed arms.",
        "Slight hip shift, friendly vibe.",
        "Hands at sides, relaxed energy.",
        "Looking back toward camera naturally.",
        "Standing tall with upbeat expression.",
        "Slight side-step pose with smile.",
        "Natural stance with bright expression.",
        "Curious upward gaze.",
        "Friendly, approachable posture.",
        "Neutral walking stance.",
        "Gentle smile with chin slightly up.",
        "Casual full-body relaxed stance.",
        "Soft half-smile, candid.",
        "Looking down softly.",
        "Slight over-the-shoulder glance.",
        "Calm observant gaze.",
        "Light playful expression.",
        "Relaxed stance, comfortable posture.",
        "Turning body to side with smile.",
        "Subtle movement-oriented stance."
    ],
    "INFLUENCER": [
        "Confident straight-on pose with soft smile.",
        "One hip angled, confident expression.",
        "Slight head tilt, flirty smile.",
        "Chin up slightly, elegant expression.",
        "Half-turned torso, refined smile.",
        "Signature influencer power pose.",
        "Over-the-shoulder confident look.",
        "Slight lean forward, charming expression.",
        "Neutral stance with charismatic energy.",
        "One leg slightly forward, poised.",
        "Casual influencer stance with small smile.",
        "Confident gaze directly at camera.",
        "Lively expression, slight lean.",
        "Soft playful smile.",
        "Slight back arch, confident posture.",
        "Influencer-style signature stance.",
        "Chin tucked slightly, cute expression.",
        "Confident wide-leg stance.",
        "Torso angled, energetic posture.",
        "Subtle hair-flip motion.",
        "Glamorous confident gaze.",
        "Strong eye-contact pose.",
        "Side-angle with charming expression.",
        "Warm influencer posture.",
        "Light half-smile, camera-ready.",
        "Calm pose with intentional angle.",
        "Head-turn with social-media flair.",
        "Relaxed yet poised posture.",
        "Bright confident expression.",
        "Full-body influencer signature stance."
    ],
    "FAMILY": [
        "Family standing close, warm smiles.",
        "Side-by-side with arms around each other.",
        "Over-the-shoulder glance between family members.",
        "Group huddle with relaxed expressions.",
        "Parents holding hands with child.",
        "Family in a V formation, smiling.",
        "Arm-in-arm warm pose.",
        "Slight staggered-height formation.",
        "Shared laughter moment.",
        "Parents leaning gently toward child.",
        "Siblings shoulder-to-shoulder.",
        "Parent kneeling to child's height.",
        "Three-quarter angled family stance.",
        "Pair or trio leaning inward.",
        "Calm, connected family posture.",
        "Holding hands in relaxed formation.",
        "Family members looking at each other affectionately.",
        "Close shoulder-touch pose.",
        "Gentle family hug.",
        "Parents behind child supportively.",
        "Siblings with heads tilted together.",
        "Family arranged by height.",
        "Semi-circle relaxed formation.",
        "Parent resting hand gently on child's back.",
        "Natural shared laugh.",
        "Group leaning slightly forward.",
        "Warm united family stance.",
        "Arms around shoulders in a line.",
        "Calm, together family posture.",
        "Slight angle group cluster."
    ],
    "BABY": [
        "Parent cradling baby gently, soft smile.",
        "Baby resting on parent's shoulder.",
        "Parent looking down lovingly at baby.",
        "Baby held securely in both arms.",
        "Parent rocking baby softly.",
        "Baby lying against parent's chest.",
        "Forehead-to-forehead parent and baby.",
        "Baby held facing outward gently.",
        "Parent holding baby angled slightly.",
        "Baby nestled close, serene expression.",
        "Baby gazing upward softly.",
        "Parent holding baby cheek-to-cheek.",
        "Baby resting in supportive hold.",
        "Parent leaning head toward baby.",
        "Baby held higher against chest.",
        "Parent supporting baby carefully.",
        "Baby resting peacefully.",
        "Parent gazing warmly at baby.",
        "Baby leaning lightly inward.",
        "Parent cuddling baby with warmth.",
        "Baby curled gently in arms.",
        "Parent smiling toward baby.",
        "Baby looking toward camera.",
        "Parent comforting baby gently.",
        "Baby upright in supportive hold.",
        "Close baby-parent bonding posture.",
        "Baby pressed softly to chest.",
        "Baby turning head slightly.",
        "Parent embracing baby protectively.",
        "Soft, loving parent-baby interaction."
    ],
    "WEDDING": [
        "Couple holding each other closely.",
        "Gentle forehead-to-forehead pose.",
        "Couple facing each other, soft smiles.",
        "Arm around waist, warm expression.",
        "Partner leaning gently inward.",
        "Bride looking up with loving eyes.",
        "Groom holding bride's waist.",
        "Soft cheek-to-cheek pose.",
        "Romantic close stance.",
        "Head on partner's shoulder.",
        "Slight lean-in of affection.",
        "Hands intertwined, serene expressions.",
        "Lovers gazing into each other's eyes.",
        "Slow dance posture.",
        "Gentle twirl (no dress detail).",
        "Admiring partner's gaze.",
        "Shy loving glance.",
        "Romantic embrace.",
        "Arm-in-arm united stance.",
        "Bride behind groom, soft embrace.",
        "Groom behind bride, warm hold.",
        "Shared laugh moment.",
        "Intimate close stance.",
        "Looking lovingly at partner.",
        "Torsos touching softly.",
        "Couple leaning together gently.",
        "Soft cheek caress.",
        "Forehead-to-forehead.",
        "Warm wedding hug.",
        "Intimate romantic posture."
    ],
    "SPORTS": [
        "Ready stance, knees bent.",
        "Light stretch pose.",
        "Sprint-start posture.",
        "Jump-ready crouch.",
        "Athletic wide stance.",
        "Balanced focused expression.",
        "Dynamic torso turn.",
        "Kneeling athletic pose.",
        "One leg forward competitive stance.",
        "Upright athletic posture.",
        "Hands-on-knees recovery posture.",
        "Strong determined stance.",
        "Warm-up torso twist.",
        "One knee raised athletic pose.",
        "Balanced agility stance.",
        "Short-stride running stance.",
        "Confident ready pose.",
        "Light mid-step motion.",
        "Strong side-profile athletic pose.",
        "Post-run recovery stance.",
        "Light mid-air athletic motion.",
        "Controlled power stance.",
        "Dynamic rotation posture.",
        "Flexed strong posture.",
        "Energy-filled upright stance.",
        "Balanced crouch.",
        "Focused athletic gaze.",
        "Light skip-step stance.",
        "Upright powerful posture.",
        "Twisted torso determined pose."
    ],
    "SEXY / ALLURING": [
        "Confident hip-shift pose, soft seductive gaze.",
        "Slight arch in back, alluring expression.",
        "Head tilted back slightly, sultry eyes.",
        "One leg crossed in front with flirty smile.",
        "Over-the-shoulder seductive look.",
        "Chin tilted down, eyes up.",
        "Soft parted lips, relaxed posture.",
        "Curved body line, confident gaze.",
        "Subtle sensual lean.",
        "Slight twist of hips, alluring look.",
        "Body angled away, looking back seductively.",
        "Gentle shoulder-reveal posture.",
        "Soft playful smile.",
        "Fluid body-line pose.",
        "Strong confident sensual stance.",
        "Side head tilt, flirty energy.",
        "Soft arch with confident vibe.",
        "Gentle curve of torso, intimate gaze.",
        "Hip popped, soft alluring eyes.",
        "Tall sensual confident stance.",
        "Light seductive expression.",
        "Downward soft gaze, alluring mood.",
        "Torso twist with flirty eyes.",
        "Seductive side lean.",
        "Calm smoldering expression.",
        "Curved silhouette pose.",
        "Slight parted-lips look.",
        "Flirtatious half-turn.",
        "Elegant, sensual stance.",
        "Bold seductive eye contact."
    ],
    "HEADSHOTS": [
        "Straight-on headshot, relaxed smile.",
        "Slight head tilt right, warm expression.",
        "Slight head tilt left, gentle smile.",
        "Chin slightly raised, confident look.",
        "Chin slightly lowered, introspective gaze.",
        "Three-quarter angle, soft eyes.",
        "Direct gaze with subtle smirk.",
        "Neutral expression, relaxed shoulders.",
        "Calm closed-mouth smile.",
        "Strong jawline angle, looking past camera.",
        "Soft friendly expression, slight turn.",
        "Gentle upward eye gaze.",
        "Confident head-back pose.",
        "Chin forward slightly, bold gaze.",
        "Relaxed head tilt, calm look.",
        "Natural laugh moment.",
        "Eyes closed softly, serene expression.",
        "Gentle half-smile.",
        "Focused thoughtful expression.",
        "Slight cheek-raise smile.",
        "Half-profile headshot.",
        "Slightly parted lips, soft gaze.",
        "Neutral business headshot.",
        "Relaxed symmetrical posture.",
        "Chin tucked slightly, serious gaze.",
        "Soft expression with slight brow lift.",
        "Light playful smile.",
        "Calm, elegant headshot.",
        "Subtle forward lean, engaging eyes.",
        "Confident direct headshot."
    ]
};
